import React from 'react';

// Security: Input sanitization function
const sanitizeText = (text) => {
  if (!text || typeof text !== 'string') return '';
  return text
    .replace(/[<>&"']/g, (char) => {
      const entities = { '<': '&lt;', '>': '&gt;', '&': '&amp;', '"': '&quot;', "'": '&#x27;' };
      return entities[char];
    })
    .substring(0, 1000);
};

const GPUSelection = ({ gpuTypes, selectedGPU, onSelectGPU, isLoading }) => {
  return (
    <div className="mb-4 md:mb-8">
      <div className="w-full max-w-full overflow-x-hidden">
        {isLoading ? (
          <div className="flex flex-wrap gap-2 sm:gap-1 md:gap-2 mt-3 sm:mt-2 md:mt-4 mb-4 sm:mb-3 md:mb-6 mx-3 sm:mx-2 md:mx-6 animate-pulse">
            {[1, 2, 3, 4].map((i) => (
              <div
                key={i}
                className="px-4 sm:px-3 md:px-4 py-3 sm:py-2 md:py-2 rounded-[0.5rem] text-center bg-[#1a1a1a] h-12 sm:h-10 md:h-9 w-24 sm:w-20 md:w-24"
              />
            ))}
          </div>
        ) : (
          <div className="flex flex-wrap gap-2 sm:gap-1 md:gap-2 mt-3 sm:mt-2 md:mt-4 mb-4 sm:mb-3 md:mb-6 mx-3 sm:mx-2 md:mx-6">
            {gpuTypes.map((gpu) => (
              <button
                key={gpu.id}
                className={`
                  px-4 sm:px-3 md:px-4 py-3 sm:py-2 md:py-2
                  rounded-[0.5rem]
                  text-center
                  text-sm sm:text-sm md:text-sm
                  min-h-[48px] sm:min-h-[40px] md:min-h-[36px]
                  transition-colors
                  font-medium
                  ${selectedGPU === gpu.id
                    ? 'bg-[#e0eacc] text-black shadow-sm'
                    : 'bg-[#1a1a1a] border border-[#333333] text-white hover:bg-[#242424] hover:border-[#444444]'
                  }
                `}
                onClick={(e) => {
                  e.preventDefault();
                  onSelectGPU(gpu.id);
                }}
              >
                {sanitizeText(gpu.label)}
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default React.memo(GPUSelection);